import React from 'react'
import { createRoot } from 'react-dom/client'
import {
  Form,
  Button,
} from 'react-bootstrap'
import { client } from './utils'
import PropTypes from 'prop-types'

const commonRequests = {
  allStudents: '/api/v1/courses/:course_id/students',
  allAssignments: '/api/v1/courses/:course_id/assignments',
  allAssignmentGroups: '/api/v1/courses/:course_id/assignment_groups',
}

class Application extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      responseData: 'The API response will appear here.',
      url: '',
      requestType: 'GET',
      requestData: '',
    }
    this.sendToCanvas = this.sendToCanvas.bind(this)
    this.handleURLChange = this.handleURLChange.bind(this)
    this.handleRequestTypeChange = this.handleRequestTypeChange.bind(this)
    this.handleDataChange = this.handleDataChange.bind(this)
    this.handleCommonRequestChange = this.handleCommonRequestChange.bind(this)
  }

  handleURLChange(e) {
    this.setState({ url: e.target.value })
  }

  handleRequestTypeChange(e) {
    this.setState({ requestType: e.target.value })
  }

  handleDataChange(e) {
    this.setState({ requestData: e.target.value })
  }

  async sendToCanvas(e) {
    e.preventDefault()
    let data = {
      request_type: this.state.requestType,
      url: this.state.url,
      request_data: JSON.stringify(this.state.requestData),
    }
    try {
      let response = await client.post(
        `/course/canvas_helper.send_to_canvas/${this.props.coursenum}`,
        data
      )
      this.setState({ responseData: response.data.data })
    } catch (err) {
      this.setState({ responseData: err.response.data })
    }
  }

  handleCommonRequestChange(e) {
    this.setState({
      url: commonRequests[e.target.value],
      requestType: 'GET',
    })
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-8 card-myed">
            <h3>Common Requests</h3>
            <Form.Group>
              <Form.Control
                as="select"
                placeholder="Request Type"
                onChange={this.handleCommonRequestChange}
              >
                <option value="">Select from common requests</option>
                <option value="allStudents">View All Students</option>
                <option value="allAssignments">View All Assignments</option>
                <option value="allAssignmentGroups">
                  View All Assignment Groups
                </option>
              </Form.Control>
            </Form.Group>
            <hr />
            <h3>Manual Inputs</h3>
            <Form horizontal>
              <Form.Group>
                <Form.Label>Canvas API URL</Form.Label>
                <Form.Control type="text" onChange={this.handleURLChange} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Request Type</Form.Label>
                <Form.Control
                as="select"
                  placeholder="Request Type"
                  onChange={this.handleRequestTypeChange}
                >
                  <option value="GET">GET</option>
                  <option value="POST">POST</option>
                  <option value="PUT">PUT</option>
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="formControlsTextArea">
                <Form.Label>Request Data (may be optional)</Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="{ key: value }"
                  onChange={this.handleDataChange}
                />
              </Form.Group>
              <Button
                type="submit"
                variant="primary"
                className="btn-myed btn-primary-myed"
                onClick={this.sendToCanvas}
              >
                Send
              </Button>
            </Form>
          </div>
          <div className="col-md-15">
            <div className="card-myed">
              <h3>Response</h3>
              <div style={{ padding: '30px' }}>
                <pre className="text-secondary">
                  {JSON.stringify(this.state.responseData, null, 4)}
                </pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Application.propTypes = {
  coursenum: PropTypes.string,
}

export const startCanvasHelper = coursenum => {
  const root = createRoot(document.getElementById('canvas-helper'))
  root.render(<Application coursenum={coursenum} />)
}
